import React, { useRef, useState } from "react";
import CrossIcon from "../../assets/svg/icons/common/cross";
import CheckIcon from "../../assets/svg/icons/common/CheckIcon";
import Plus from "../../assets/svg/icons/common/Plus";
import { useClickAway } from "../../hooks/general/useClickAway";
import Spinner from "../Loaders/Spinner";
import EquipmentConfigurator from "../brand/equipment-configurator";
import styles from "../brand/styles.module.scss";

const EquipmentItem = ({
  equipment,
  image,
  handleAddEquipment,
  handleRemoveAllEquipments,
  noShadow = false,
  disabled = false,
  equipmentConfigurator = false,
  allSelectedEquipments = [],
  selectedEquipment = null,
  allEquipments = [],
  equipmentBeingConfigured = null,
  handleAddConfiguredEquipment = null,
  onEquipmentChange = null,
  onClickOutside = null,
}) => {
  const { equipment_name, equipment_type } = equipment;
  const isGateway = equipment_type === "gateway";
  const isSelected = selectedEquipment?.length > 0;
  const totalQuantity =
    isSelected &&
    selectedEquipment.reduce((acc, curr) => acc + curr.quantity, 0);
  const configAreaRef = useRef(null);
  const [configuring, setConfiguring] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const selectedClass = isSelected ? styles.selected : "";
  const configuringClass = configuring ? styles.configuring : "";

  const equipmentRef = useClickAway(() => {
    if (configuring) {
      setConfiguring(false);
      onClickOutside?.();
    }
  });
  return (
    <article
      className={`${styles.equipment} ${selectedClass} ${configuringClass} ${
        noShadow && styles.noShadow
      } ${disabled && styles.disabled}`}
      ref={equipmentRef}
    >
      {isSelected && (
        <span
          className={`${styles.selectedCircleEquipment} ${styles.selectedCircle}`}
          onClick={() => {
            if (!disabled) {
              handleRemoveAllEquipments([equipment.id]);
            }
          }}
        >
          {isGateway ? (
            <CheckIcon className={styles.checkIcon} />
          ) : (
            <span className={styles.count}>{totalQuantity}</span>
          )}
          <CrossIcon />
        </span>
      )}
      <div
        className={styles.imageContainer}
        onClick={() => {
          setConfiguring((prev) => !prev);
          handleAddEquipment(equipment.id);
        }}
      >
        {imageLoading && (
          <span className={styles.spinnerContainer}>
            <Spinner />
          </span>
        )}

        <img
          src={image}
          alt={`${equipment_name} logo`}
          onLoad={() => setImageLoading(false)}
          onError={() => setImageLoading(false)}
          style={{ display: imageLoading ? "none" : "block" }}
        />
        {!isSelected && (
          <div className={styles.selectionCircle}>
            <Plus />
          </div>
        )}
      </div>

      <div className={styles.nameArea}>
        <h1 className={styles.title}>{equipment_name}</h1>
      </div>

      {configuring && (
        <div className={`${styles.configurationArea}`} ref={configAreaRef}>
          {equipmentBeingConfigured && (
            <EquipmentConfigurator
              equipment={equipmentBeingConfigured}
              allSelectedEquipments={allSelectedEquipments}
              allEquipments={allEquipments}
              onEquipmentChange={onEquipmentChange}
              handleAddConfiguredEquipment={(type, quantity) => {
                handleAddConfiguredEquipment(type, quantity);
                setConfiguring(false);
              }}
              isSelected={isSelected}
              handleRemoveAll={() => {
                setConfiguring(false);
                handleRemoveAllEquipments([equipment.id]);
              }}
            />
          )}
        </div>
      )}
    </article>
  );
};

export default EquipmentItem;
